import { useState, useRef } from "react";

// ── Constants ────────────────────────────────────────────────────────────────
const ZONES = [
  { id: "tl", label: "Top Left",      x: "18%",  y: "18%" },
  { id: "tc", label: "Top Centre",    x: "50%",  y: "12%" },
  { id: "tr", label: "Top Right",     x: "82%",  y: "18%" },
  { id: "ml", label: "Mid Left",      x: "22%",  y: "50%" },
  { id: "mc", label: "Mid Centre",    x: "50%",  y: "46%" },
  { id: "mr", label: "Mid Right",     x: "78%",  y: "50%" },
  { id: "bl", label: "Bottom Left",   x: "28%",  y: "76%" },
  { id: "bc", label: "Bottom Centre", x: "50%",  y: "78%" },
  { id: "br", label: "Bottom Right",  x: "72%",  y: "76%" },
];

function getRandom(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
function getKeeperZone() { return getRandom(ZONES).id; }

const GOAL_COMMENTS = [
  "GOAL! Right in the corner — no chance! 🎉",
  "GOAL! Thunderbolt into the top left! 🎉",
  "GOAL! Cool as you like — keeper rooted! 🎉",
  "GOAL! The keeper goes the wrong way! 🎉",
  "GOAL! What a strike — the net bulges! 🎉",
  "GOAL! Unstoppable! 🎉",
];
const SAVE_COMMENTS = [
  "SAVED! The keeper dives the right way! 🧤",
  "Unbelievable stop! Gets a hand to it! 🧤",
  "Denied! The keeper reads it perfectly! 🧤",
  "What a save! The crowd can't believe it! 🧤",
  "The keeper flies across — fingertips! 🧤",
];
const MISS_COMMENTS = [
  "Blazed over the bar! Oh no! 😬",
  "Wide left! The pressure got to them! 😬",
  "Rattles the post and stays out! 😬",
];

// ── Goalkeeper SVG ────────────────────────────────────────────────────────────
function Goalkeeper({ diving, diveZone }) {
  // Work out dive transform
  let bodyTransform = "translate(0,0) rotate(0deg)";
  let gloveL = { x: -18, y: -28 };
  let gloveR = { x: 18, y: -28 };

  if (diving && diveZone) {
    const isLeft  = diveZone.endsWith("l");
    const isRight = diveZone.endsWith("r");
    const isTop   = diveZone.startsWith("t");
    

    if (isLeft) {
      bodyTransform = "translate(-44px, 10px) rotate(-50deg)";
      gloveL = { x: -32, y: -14 };
      gloveR = { x: 8,   y: -36 };
    } else if (isRight) {
      bodyTransform = "translate(44px, 10px) rotate(50deg)";
      gloveL = { x: -8,  y: -36 };
      gloveR = { x: 32,  y: -14 };
    } else if (isTop) {
      bodyTransform = "translate(0, -24px) rotate(0deg)";
      gloveL = { x: -22, y: -46 };
      gloveR = { x: 22,  y: -46 };
    } else {
      bodyTransform = "translate(0, 6px) rotate(0deg)";
      gloveL = { x: -22, y: -10 };
      gloveR = { x: 22,  y: -10 };
    }
  }

  return (
    <div style={{
      position: "absolute",
      bottom: "20%",
      left: "50%",
      transform: `translateX(-50%)`,
      width: 80,
      height: 100,
      zIndex: 3,
    }}>
      <svg
        viewBox="-40 -80 80 90"
        width="80"
        height="90"
        style={{
          overflow: "visible",
          transform: bodyTransform,
          transition: "transform 0.32s cubic-bezier(.3,1.5,.5,1)",
          filter: "drop-shadow(0 4px 10px #000b)",
        }}
      >
        {/* ── Kit: yellow goalkeeper shirt ── */}
        {/* Legs */}
        <rect x="-10" y="-6" width="9" height="28" rx="4" fill="#1e3a5f" />
        <rect x="1"   y="-6" width="9" height="28" rx="4" fill="#1e3a5f" />
        {/* Boots */}
        <ellipse cx="-6"  cy="24" rx="8" ry="5" fill="#111" />
        <ellipse cx="6"   cy="24" rx="8" ry="5" fill="#111" />
        {/* Shirt body */}
        <rect x="-16" y="-38" width="32" height="34" rx="6" fill="#f59e0b" />
        {/* Shirt stripe */}
        <rect x="-4"  y="-38" width="8"  height="34" rx="2" fill="#fbbf24" opacity="0.5" />
        {/* Arms */}
        <rect x="-26" y="-36" width="12" height="9" rx="4" fill="#f59e0b" />
        <rect x="14"  y="-36" width="12" height="9" rx="4" fill="#f59e0b" />
        {/* Gloves */}
        <ellipse cx={gloveL.x} cy={gloveL.y} rx="9" ry="8" fill="#10b981"
          style={{ transition: "cx 0.32s cubic-bezier(.3,1.5,.5,1), cy 0.32s cubic-bezier(.3,1.5,.5,1)" }}
        />
        <ellipse cx={gloveR.x} cy={gloveR.y} rx="9" ry="8" fill="#10b981"
          style={{ transition: "cx 0.32s cubic-bezier(.3,1.5,.5,1), cy 0.32s cubic-bezier(.3,1.5,.5,1)" }}
        />
        {/* Glove fingers detail */}
        <line x1={gloveL.x-5} y1={gloveL.y-4} x2={gloveL.x-5} y2={gloveL.y+4} stroke="#065f46" strokeWidth="1.5" />
        <line x1={gloveL.x}   y1={gloveL.y-6} x2={gloveL.x}   y2={gloveL.y+4} stroke="#065f46" strokeWidth="1.5" />
        <line x1={gloveL.x+5} y1={gloveL.y-4} x2={gloveL.x+5} y2={gloveL.y+4} stroke="#065f46" strokeWidth="1.5" />
        <line x1={gloveR.x-5} y1={gloveR.y-4} x2={gloveR.x-5} y2={gloveR.y+4} stroke="#065f46" strokeWidth="1.5" />
        <line x1={gloveR.x}   y1={gloveR.y-6} x2={gloveR.x}   y2={gloveR.y+4} stroke="#065f46" strokeWidth="1.5" />
        <line x1={gloveR.x+5} y1={gloveR.y-4} x2={gloveR.x+5} y2={gloveR.y+4} stroke="#065f46" strokeWidth="1.5" />
        {/* Neck */}
        <rect x="-6" y="-48" width="12" height="12" rx="4" fill="#f5c5a3" />
        {/* Head */}
        <ellipse cx="0" cy="-58" rx="14" ry="13" fill="#f5c5a3" />
        {/* Hair */}
        <ellipse cx="0" cy="-68" rx="14" ry="7" fill="#92400e" />
        {/* Eyes */}
        <circle cx="-5" cy="-58" r="2.5" fill="#1f2937" />
        <circle cx="5"  cy="-58" r="2.5" fill="#1f2937" />
        <circle cx="-4" cy="-58" r="1"   fill="#fff" />
        <circle cx="6"  cy="-58" r="1"   fill="#fff" />
        {/* Mouth — determined expression */}
        <path d="M -4 -52 Q 0 -50 4 -52" stroke="#c2410c" strokeWidth="1.5" fill="none" />
        {/* Goalkeeper gloves text */}
        <text x={gloveL.x} y={gloveL.y+2} textAnchor="middle" fill="#fff" fontSize="4" fontWeight="bold">GK</text>
        <text x={gloveR.x} y={gloveR.y+2} textAnchor="middle" fill="#fff" fontSize="4" fontWeight="bold">GK</text>
      </svg>
    </div>
  );
}

// ── Ball ──────────────────────────────────────────────────────────────────────
function Ball({ shooting, targetZone, result }) {
  const zone = ZONES.find(z => z.id === targetZone);
  const isMiss = result === "miss";

  const style = shooting && targetZone ? {
    position: "absolute",
    left: zone?.x || "50%",
    top: isMiss ? "-10%" : zone?.y || "50%",
    transform: "translate(-50%, -50%) scale(0.7)",
    transition: "all 0.5s cubic-bezier(.2,1.2,.5,1)",
    fontSize: 26,
    zIndex: 4,
    opacity: isMiss ? 0 : 1,
    filter: "drop-shadow(0 4px 12px #000c)",
  } : {
    position: "absolute",
    bottom: "6%",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: 26,
    zIndex: 4,
    filter: "drop-shadow(0 2px 8px #000a)",
  };

  return <div style={style}>⚽</div>;
}

// ── Goal ──────────────────────────────────────────────────────────────────────
function Goal() {
  return (
    <div style={{
      position: "absolute", top: "6%", left: "50%",
      transform: "translateX(-50%)",
      width: "74%", height: "54%",
      border: "4px solid #fff",
      borderBottom: "none",
      borderRadius: "4px 4px 0 0",
      boxShadow: "0 0 0 2px #0006, inset 0 0 40px #ffffff06",
      zIndex: 1,
      background: "linear-gradient(180deg,#ffffff06 0%,transparent 100%)",
    }}>
      {[25,50,75].map(p => <div key={p} style={{ position:"absolute", top:`${p}%`, left:0, right:0, height:1, background:"#ffffff18" }} />)}
      {[20,40,60,80].map(p => <div key={p} style={{ position:"absolute", left:`${p}%`, top:0, bottom:0, width:1, background:"#ffffff18" }} />)}
    </div>
  );
}

// ── Zone Buttons ──────────────────────────────────────────────────────────────
function ZoneButtons({ onShoot, disabled }) {
  return (
    <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:8, width:"100%", maxWidth:340 }}>
      {ZONES.map(zone => (
        <button key={zone.id} onClick={() => onShoot(zone.id)} disabled={disabled}
          style={{
            background: disabled ? "#1f2937" : "#ffffff10",
            border: "1px solid #ffffff20",
            borderRadius: 10, color: disabled ? "#4b5563" : "#f9fafb",
            padding: "10px 4px", fontSize: 11, fontWeight: 700,
            fontFamily: "'Oswald', sans-serif", letterSpacing: 0.5,
            cursor: disabled ? "not-allowed" : "pointer", transition: "all 0.15s",
          }}
          onMouseEnter={e => { if (!disabled) { e.currentTarget.style.background="#10b98133"; e.currentTarget.style.borderColor="#10b981"; }}}
          onMouseLeave={e => { e.currentTarget.style.background=disabled?"#1f2937":"#ffffff10"; e.currentTarget.style.borderColor="#ffffff20"; }}
        >{zone.label}</button>
      ))}
    </div>
  );
}

// ── Score Dots ────────────────────────────────────────────────────────────────
function ScoreRow({ scored, total, taken }) {
  return (
    <div style={{ display:"flex", gap:8, justifyContent:"center" }}>
      {Array.from({ length: total }).map((_,i) => {
        const t = i < taken;
        const g = i < scored;
        return (
          <div key={i} style={{
            width:34, height:34, borderRadius:"50%",
            border:`2px solid ${t?(g?"#10b981":"#ef4444"):"#374151"}`,
            background: t?(g?"#10b98133":"#ef444422"):"transparent",
            display:"flex", alignItems:"center", justifyContent:"center",
            fontSize:16, transition:"all 0.3s",
          }}>{t?(g?"⚽":"❌"):""}</div>
        );
      })}
    </div>
  );
}

// ── Main App ──────────────────────────────────────────────────────────────────
export default function PenaltyShootout() {
  const TOTAL = 5;
  const [phase, setPhase]       = useState("intro");
  const [scored, setScored]     = useState(0);
  const [taken, setTaken]       = useState(0);
  const [shooting, setShooting] = useState(false);
  const [targetZone, setTarget] = useState(null);
  const [keeperZone, setKeeper] = useState(null);
  const [result, setResult]     = useState(null);
  const [comment, setComment]   = useState("");
  const [history, setHistory]   = useState([]);
  const [showZones, setShowZones] = useState(true);
  const timer = useRef(null);

  const shoot = (zoneId) => {
    if (shooting || taken >= TOTAL) return;
    setShooting(true);
    setShowZones(false);
    const kZone = getKeeperZone();
    setKeeper(kZone);
    setTarget(zoneId);
    const miss = Math.random() < 0.1;
    const outcome = miss ? "miss" : kZone === zoneId ? "saved" : "goal";

    timer.current = setTimeout(() => {
      setResult(outcome);
      const ns = outcome === "goal" ? scored + 1 : scored;
      const nt = taken + 1;
      setScored(ns); setTaken(nt);
      setHistory(h => [...h, outcome]);
      setComment(outcome==="goal" ? getRandom(GOAL_COMMENTS) : outcome==="saved" ? getRandom(SAVE_COMMENTS) : getRandom(MISS_COMMENTS));

      timer.current = setTimeout(() => {
        setShooting(false); setTarget(null); setKeeper(null);
        setResult(null); setComment(""); setShowZones(true);
        if (nt >= TOTAL) setTimeout(() => setPhase("result"), 300);
      }, 1900);
    }, 550);
  };

  const restart = () => {
    setScored(0); setTaken(0); setShooting(false); setTarget(null);
    setKeeper(null); setResult(null); setComment(""); setHistory([]);
    setShowZones(true); setPhase("playing");
  };

  const getRating = () => {
    if (scored===5) return { emoji:"🏆", title:"World Class!",   msg:"Perfect 5/5 — you're a penalty king!" };
    if (scored===4) return { emoji:"⭐", title:"Excellent!",     msg:"4/5 — nerves of steel!" };
    if (scored===3) return { emoji:"👍", title:"Solid!",         msg:"3/5 — decent effort, keep practicing!" };
    if (scored===2) return { emoji:"😅", title:"Keep Trying!",   msg:"2/5 — the keeper had your number!" };
    if (scored===1) return { emoji:"😬", title:"Rough Day!",     msg:"1/5 — maybe stick to managing?" };
    return             { emoji:"🙈", title:"Oh Dear!",        msg:"0/5 — the keeper didn't break a sweat!" };
  };

  const s = { fontFamily:"'Inter','Segoe UI',sans-serif" };

  // ── INTRO ──
  if (phase==="intro") return (
    <div style={{ ...s, minHeight:"100vh", background:"#0d1117", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
      <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@400;600;700&family=Inter:wght@400;500;600&display=swap" rel="stylesheet" />
      <style>{`@keyframes bounce{from{transform:translateY(0)}to{transform:translateY(-14px)}} @keyframes pulse{0%,100%{opacity:1}50%{opacity:0.5}}`}</style>
      <div style={{ textAlign:"center", maxWidth:400 }}>
        <div style={{ fontSize:80, marginBottom:16, display:"inline-block", animation:"bounce 0.8s infinite alternate" }}>⚽</div>
        <div style={{ color:"#10b981", fontFamily:"'Oswald',sans-serif", fontSize:11, letterSpacing:4, marginBottom:8 }}>GRASSROOTING</div>
        <h1 style={{ color:"#f9fafb", fontFamily:"'Oswald',sans-serif", fontSize:38, fontWeight:700, marginBottom:8, lineHeight:1.1 }}>PENALTY<br/>SHOOTOUT</h1>
        <p style={{ color:"#6b7280", fontSize:13, lineHeight:1.7, marginBottom:32 }}>5 penalties. Pick your spot.<br/>Beat the keeper. How many can you score?</p>
        <button onClick={()=>setPhase("playing")} style={{ background:"#10b981", color:"#fff", border:"none", borderRadius:12, padding:"14px 44px", fontFamily:"'Oswald',sans-serif", fontWeight:700, fontSize:20, cursor:"pointer", letterSpacing:1, boxShadow:"0 4px 28px #10b98144" }}>
          STEP UP ⚽
        </button>
        <div style={{ color:"#374151", fontSize:11, marginTop:20 }}>Tap a zone to place your shot</div>
      </div>
    </div>
  );

  // ── RESULT ──
  if (phase==="result") {
    const r = getRating();
    return (
      <div style={{ ...s, minHeight:"100vh", background:"#0d1117", display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
        <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@400;600;700&family=Inter:wght@400;500;600&display=swap" rel="stylesheet" />
        <div style={{ textAlign:"center", maxWidth:400, width:"100%" }}>
          <div style={{ fontSize:72, marginBottom:12 }}>{r.emoji}</div>
          <div style={{ color:"#10b981", fontFamily:"'Oswald',sans-serif", fontSize:11, letterSpacing:4, marginBottom:8 }}>FINAL SCORE</div>
          <div style={{ color:"#f9fafb", fontFamily:"'Oswald',sans-serif", fontSize:68, fontWeight:700, lineHeight:1, marginBottom:4 }}>
            {scored}<span style={{ color:"#374151", fontSize:36 }}>/5</span>
          </div>
          <div style={{ color:"#10b981", fontFamily:"'Oswald',sans-serif", fontSize:24, fontWeight:700, marginBottom:8 }}>{r.title}</div>
          <div style={{ color:"#9ca3af", fontSize:14, marginBottom:28, lineHeight:1.6 }}>{r.msg}</div>
          <div style={{ display:"flex", gap:10, justifyContent:"center", marginBottom:28 }}>
            {history.map((h,i) => (
              <div key={i} style={{ width:36, height:36, borderRadius:"50%", background:h==="goal"?"#10b98133":"#ef444422", border:`2px solid ${h==="goal"?"#10b981":"#ef4444"}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:18 }}>
                {h==="goal"?"⚽":"❌"}
              </div>
            ))}
          </div>
          <div style={{ display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap", marginBottom:28 }}>
            <button onClick={restart} style={{ background:"#10b981", color:"#fff", border:"none", borderRadius:10, padding:"12px 28px", fontFamily:"'Oswald',sans-serif", fontWeight:700, fontSize:15, cursor:"pointer", letterSpacing:1 }}>TAKE AGAIN 🔄</button>
            <button onClick={()=>setPhase("intro")} style={{ background:"#1f2937", color:"#9ca3af", border:"1px solid #374151", borderRadius:10, padding:"12px 28px", fontFamily:"'Oswald',sans-serif", fontWeight:700, fontSize:15, cursor:"pointer" }}>HOME</button>
          </div>
          <div style={{ background:"#111827", border:"1px solid #1f2937", borderRadius:12, padding:"16px 20px" }}>
            <div style={{ color:"#10b981", fontFamily:"'Oswald',sans-serif", fontSize:12, letterSpacing:2, marginBottom:6 }}>PLAYED ON GRASSROOTING</div>
            <div style={{ color:"#6b7280", fontSize:12, lineHeight:1.6 }}>Find grassroots football teams near you — U7 to U16, every league, everywhere.</div>
            <div style={{ color:"#10b981", fontSize:12, fontWeight:700, marginTop:6 }}>grassrooting.co.uk ⚽</div>
          </div>
        </div>
      </div>
    );
  }

  // ── GAME ──
  return (
    <div style={{ ...s, minHeight:"100vh", background:"#0d1117", display:"flex", flexDirection:"column", alignItems:"center", padding:"20px 16px", gap:16 }}>
      <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@400;600;700&family=Inter:wght@400;500;600&display=swap" rel="stylesheet" />
      <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:0.4}}`}</style>

      {/* Header */}
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", width:"100%", maxWidth:400 }}>
        <div>
          <span style={{ color:"#f9fafb", fontFamily:"'Oswald',sans-serif", fontSize:18, fontWeight:700, letterSpacing:1 }}>GRASS</span>
          <span style={{ color:"#10b981", fontFamily:"'Oswald',sans-serif", fontSize:18, fontWeight:700, letterSpacing:1 }}>ROOTING</span>
        </div>
        <div style={{ background:"#111827", border:"1px solid #1f2937", borderRadius:20, padding:"4px 16px" }}>
          <span style={{ color:"#10b981", fontFamily:"'Oswald',sans-serif", fontWeight:700, fontSize:18 }}>{scored}</span>
          <span style={{ color:"#4b5563", fontFamily:"'Oswald',sans-serif", fontSize:14 }}> / {TOTAL}</span>
        </div>
      </div>

      <ScoreRow scored={scored} total={TOTAL} taken={taken} />

      {/* Pitch */}
      <div style={{ position:"relative", width:"100%", maxWidth:400, height:280, background:"linear-gradient(180deg,#14532d 0%,#166534 40%,#15803d 100%)", borderRadius:16, overflow:"hidden", border:"2px solid #166534", boxShadow:"0 8px 32px #000a" }}>
        {/* Pitch markings */}
        <div style={{ position:"absolute", bottom:0, left:"18%", right:"18%", height:"36%", border:"2px solid #ffffff20", borderBottom:"none", borderRadius:"4px 4px 0 0" }} />
        <div style={{ position:"absolute", bottom:0, left:"34%", right:"34%", height:"18%", border:"2px solid #ffffff20", borderBottom:"none" }} />
        <div style={{ position:"absolute", bottom:"18%", left:"50%", transform:"translateX(-50%)", width:56, height:56, borderRadius:"50%", border:"2px solid #ffffff20" }} />
        <div style={{ position:"absolute", bottom:"18%", left:"50%", transform:"translateX(-50%) translateX(-3px)", width:6, height:6, borderRadius:"50%", background:"#ffffff33" }} />

        <Goal />
        <Goalkeeper diving={shooting} diveZone={keeperZone} />
        <Ball shooting={shooting} targetZone={targetZone} result={result} />

        {/* Result flash */}
        {result && (
          <div style={{ position:"absolute", inset:0, display:"flex", alignItems:"center", justifyContent:"center", background:result==="goal"?"#10b98118":"#ef444418", zIndex:10, borderRadius:14 }}>
            <div style={{ fontSize:60 }}>{result==="goal"?"🎉":result==="saved"?"🧤":"😬"}</div>
          </div>
        )}
      </div>

      {/* Commentary */}
      <div style={{ minHeight:32, textAlign:"center", maxWidth:340 }}>
        {comment
          ? <div style={{ color:comment.includes("GOAL")?"#10b981":comment.includes("SAVED")||comment.includes("save")||comment.includes("stop")||comment.includes("flies")||comment.includes("Denied")||comment.includes("Unbelievable")?"#f59e0b":"#ef4444", fontFamily:"'Oswald',sans-serif", fontSize:15, fontWeight:700, letterSpacing:0.5 }}>{comment}</div>
          : <div style={{ color:"#4b5563", fontSize:13 }}>{taken < TOTAL ? `Penalty ${taken+1} of ${TOTAL} — pick your spot` : ""}</div>
        }
      </div>

      {showZones && taken < TOTAL && <ZoneButtons onShoot={shoot} disabled={shooting} />}
      {shooting && <div style={{ color:"#6b7280", fontSize:13, animation:"pulse 0.6s infinite" }}>Shooting...</div>}
    </div>
  );
}
